import React, { useState } from 'react'

import onChangeForm from './lib/form-change-retriever'
import onFetchSuccess from './lib/fetch-success-handler'
import onFetchFailure from './lib/fetch-failure-handler'
import createContent from './lib/content-creator'
import validate from './lib/validator'

const create = ({
  Component,
  schema,
  apiUrl,
  successText,
  initialData = {},
  onSuccess
}) => {
  const Container = (props) => {
    const [waiting, setWaiting] = useState(false)
    const [errors, setErrors] = useState({})
    const [successMessage, setSuccessMessage] = useState()
    const [errorMessage, setErrorMessage] = useState()
    const [data, setData] = useState(initialData)

    const clearErrors = () => {
      setErrors({})
    }

    const onChange = (e, i) => {
      onChangeForm(e, i, setData, data)
    }

    const addErrors = (newErrors) => {
      setErrors({ ...errors, ...newErrors })
    }

    const onSubmitted = () => {
      window.scrollTo(0, 0)
      setWaiting(true)
    }

    const onResponse = () => {
      setWaiting(false)
    }

    const setValues = (values) => {
      setData({
        ...data,
        ...values
      })
    }

    const onSubmit = async (e) => {
      e && e.preventDefault()
      try {
        clearErrors()
        const errors = await validate(schema, data, setErrors)

        if (errors) return

        const content = createContent(data)

        onSubmitted()

        const res = await fetch(apiUrl, content)

        onResponse()

        if (res.status === 200) {
          return await onFetchSuccess(
            res,
            setData,
            data,
            onSuccess,
            setSuccessMessage,
            successText
          )
        }

        const json = await res.json()
        onFetchFailure(json, setErrors, setErrorMessage)
      } catch (err) {
        setWaiting(false)
        setErrors(errorMessage)
      }
    }

    return (
      <>
        <Component
          handleOnChange={onChange}
          handleOnSubmit={onSubmit}
          setValues={setValues}
          setErrors={addErrors}
          successMessage={successMessage}
          errorMessage={errorMessage}
          waiting={waiting}
          errors={errors}
          data={data}
          {...props}
        />
      </>
    )
  }

  return Container
}

export default create
